<template>
  <v-dialog
    v-model="computedSnowmakingPipeleaksVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('snowmaking', 'pipeleaks', false);
            date = null;
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedName }} {{ computedLoc }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates,
                level: 18
              });
              // check if map layer is visible, toggle on if not so when we zoom to location
              // there is a dot to zoom to
              methodCloseListLayer('snowmaking', 'pipeleaks');
              methodToggleSingleLayer('snowmaking', 'pipeleaks', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>
        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            :color="disable_edit ? '' : 'primary'"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedSnowmakingPipeleaksGeoJsonFeature"
          :loading="computedSnowmakingPipeleakssLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Text</td>
              <td>
                <v-text-field
                  ref="ref_text"
                  v-model="props.item.properties.text"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>False alarm?</td>
              <td>
                <v-select
                  ref="ref_false_alarm"
                  :items="opt_yes_no"
                  v-model="props.item.properties.false_alarm"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Mountain</td>
              <td>
                <v-select
                  ref="ref_mountain"
                  :items="opt_mountain"
                  v-model="props.item.properties.mountain"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Run pipeline</td>
              <td>
                <v-text-field
                  ref="ref_run_pipeli"
                  v-model="props.item.properties.run_pipeli"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Location details</td>
              <td>
                <v-text-field
                  ref="ref_loc_detail"
                  v-model="props.item.properties.loc_detail"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Leak type</td>
              <td>
                <v-select
                  ref="ref_leak_type"
                  :items="opt_leak_type"
                  v-model="props.item.properties.leak_type"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Pipe diameter (inch)</td>
              <td>
                <v-select
                  ref="ref_pipe_diam"
                  :items="opt_pipe_diam"
                  v-model="props.item.properties.pipe_diam"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Pipe material</td>
              <td>
                <v-select
                  ref="ref_pipe_mater"
                  :items="opt_pipe_mater"
                  v-model="props.item.properties.pipe_mater"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Rupture type</td>
              <td>
                <v-select
                  ref="ref_rupt_type"
                  :items="opt_rupt_type"
                  v-model="props.item.properties.rupt_type"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Estimated flow (GPM)</td>
              <td>
                <v-text-field
                  ref="ref_estflowgpm"
                  v-model="props.item.properties.estflowgpm"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Discovery date</td>
              <td>
                <v-menu
                  ref="menu_disc_date"
                  v-model="menu_disc_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="ref_disc_date"
                      v-model="props.item.properties.disc_date"
                      :disabled="disable_edit"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="props.item.properties.disc_date"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu_disc_date = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_disc_date.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
            <tr>
              <td>Discovered by</td>
              <td>
                <v-text-field
                  ref="ref_dics_by"
                  v-model="props.item.properties.dics_by"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Confirmation date</td>
              <td>
                <v-menu
                  ref="menu_conf_date"
                  v-model="menu_conf_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="ref_conf_date"
                      v-model="props.item.properties.conf_date"
                      :disabled="disable_edit"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="props.item.properties.conf_date"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu_conf_date = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_conf_date.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
            <tr>
              <td>Confirmed by</td>
              <td>
                <v-select
                  ref="ref_conf_by"
                  :items="opt_conf_by"
                  v-model="props.item.properties.conf_by"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Repair date</td>
              <td>
                <v-menu
                  ref="menu_rep_date"
                  v-model="menu_rep_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="ref_rep_date"
                      v-model="props.item.properties.rep_date"
                      :disabled="disable_edit"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="props.item.properties.rep_date"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu_rep_date = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_rep_date.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
            <tr>
              <td>Repaired by</td>
              <td>
                <v-text-field
                  ref="ref_rep_by"
                  v-model="props.item.properties.rep_by"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Repair complete</td>
              <td>
                <v-select
                  ref="ref_rep_comple"
                  :items="opt_yes_no"
                  v-model="props.item.properties.rep_comple"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  ref="ref_comments"
                  v-model="props.item.properties.comments"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditSnowmakingPipeleaksGeoJson({
                      text: $refs.ref_text.value,
                      mountain: $refs.ref_mountain.value,
                      run_pipeli: $refs.ref_run_pipeli.value,
                      loc_detail: $refs.ref_loc_detail.value,
                      leak_type: $refs.ref_leak_type.value,
                      pipe_diam: $refs.ref_pipe_diam.value,
                      pipe_mater: $refs.ref_pipe_mater.value,
                      rupt_type: $refs.ref_rupt_type.value,
                      estflowgpm: $refs.ref_estflowgpm.value,
                      disc_date: $refs.ref_disc_date.value,
                      conf_date: $refs.ref_conf_date.value,
                      conf_by: $refs.ref_conf_by.value,
                      rep_date: $refs.ref_rep_date.value,
                      rep_by: $refs.ref_rep_by.value,
                      rep_comple: $refs.ref_rep_comple.value,
                      comments: $refs.ref_comments.value,
                      dics_by: $refs.ref_dics_by.value,
                      false_alarm: $refs.ref_false_alarm.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('snowmaking', 'pipeleaks', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >

                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodDeleteSnowmakingPipeleaksGeoJson();
              methodToggleSingleLayer('snowmaking', 'pipeleaks', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      date: null,
      menu_disc_date: false,
      menu_conf_date: false,
      menu_rep_date: false,
      disable_edit: true,
      confirm_delete: false,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      opt_max_load: [
        { text: "Bike" },
        { text: "UTV" },
        { text: "Heavy Machinery" }
      ],
      opt_leak_type: [{ text: "Water" }, { text: "Air" }],
      opt_pipe_diam: [
        { text: 2 },
        { text: 4 },
        { text: 6 },
        { text: 8 },
        { text: 10 },
        { text: 12 },
        { text: 16 }
      ],
      opt_pipe_mater: [
        { text: "Steel" },
        { text: "HDPE" },
        { text: "Unknown" }
      ],
      opt_rupt_type: [
        { text: "Tear" },
        { text: "Pin Hole" },
        { text: "Failed weld" },
        { text: "Failed fuse" }
      ],
      opt_conf_by: [
        { text: "Gyser" },
        { text: "Draining Pipe" },
        { text: "Blowhole" }
      ],
      opt_yes_no: [{ text: "Yes" }, { text: "No" }]
    };
  },
  computed: {
    computedLatLng() {
      if (this.computedSnowmakingPipeleaksVisibility) {
        const pipeleaks = this.$store.state.mapLayers.snowmaking.layers
          .pipeleaks.geojson.features;
        const result = pipeleaks.filter(
          item => item.properties.id == this.computedSnowmakingPipeleaksId
        );
        return result;
      }
      return [];
    },
    computedName() {
      let res;
      if (this.computedSnowmakingPipeleaksVisibility) {
        const points = this.$store.state.mapLayers.snowmaking.layers.pipeleaks
          .geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedSnowmakingPipeleaksId
        );
        res = result[0].properties.trail_name;
      }
      return res;
    },
    computedLoc() {
      let res;
      if (this.computedSnowmakingPipeleaksVisibility) {
        const points = this.$store.state.mapLayers.snowmaking.layers.pipeleaks
          .geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedSnowmakingPipeleaksId
        );
        res = result[0].properties.sign_loc;
      }
      return res;
    },
    computedUniqueRunPipelines() {
      const trail_names = this.$store.state.mapLayers.snowmaking.layers
        .pipeleaks.geojson.features;
      const trailNames = [];
      trail_names.map(item => {
        trailNames.push(item.properties.run_pipeli);
      });
      const uniqueTrails = Array.from(new Set(trailNames));
      let finalResults = [];
      uniqueTrails.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedUniqueLocations() {
      const locations = this.$store.state.mapLayers.snowmaking.layers.pipeleaks
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].properties.sign_loc !== null) {
          a.push(locations[i].properties.sign_loc); // push all sign locations into array a
        }
      }
      return a.unique().sort(); // returns sorted unique sign locations
    },
    computedSnowmakingPipeleaksGeoJsonFeature() {
      let res;
      if (
        this.$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson.features
      ) {
        const points = this.$store.state.mapLayers.snowmaking.layers.pipeleaks
          .geojson.features;
        const result = points.filter(
          item => item.properties.id == this.computedSnowmakingPipeleaksId
        );
        res = result;
      }
      return res;
    },
    computedSnowmakingPipeleaksVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility
        .singleView;
    },
    computedSnowmakingPipeleakssLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.loading;
    },
    computedSnowmakingPipeleaksId() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingPipeleaksGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
        dept: "snowmaking",
        layer: "pipeleaks",
        token: this.computedAuthToken
      });
    },
    methodEditSnowmakingPipeleaksGeoJson(data) {
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks/" +
            this.computedSnowmakingPipeleaksId,
          dept: "snowmaking",
          layer: "pipeleaks",
          token: this.computedAuthToken,
          payload: data
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetSnowmakingPipeleaksGeoJson();
          }, 250);
        });
    },
    methodDeleteSnowmakingPipeleaksGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks/" +
            this.computedSnowmakingPipeleaksId,
          dept: "snowmaking",
          layer: "pipeleaks",
          token: this.computedAuthToken
        })
        .then(
          setTimeout(() => {
            this.methodGetSnowmakingPipeleaksGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingPipeleaksGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
